import {
  Component,
  Input,
  OnInit,
  Output,
  EventEmitter,
  ChangeDetectorRef,
  SimpleChanges,
} from "@angular/core";
import { CommonModule } from "@angular/common";
import { DrawerComponent } from "./../drawer/drawer.component";
import { CustomDataService } from "../../main/accountant/setup-and-settings/client-contact-fields/custom-data.service";
import { BsDropdownModule } from "ngx-bootstrap/dropdown";
import { GenericDrawerService } from "../../drawer/global-drawer.service";
import { EmptyStateComponent } from "src/app/design-system/components/empty-state/empty-state.component";

@Component({
  selector: "people-section",
  imports: [
    CommonModule,
    DrawerComponent,
    BsDropdownModule,
    EmptyStateComponent,
  ],
  templateUrl: "./people-section.component.html",
  styleUrls: ["./people-section.component.scss"],
})
export class PeopleSectionComponent implements OnInit {
  showUsers: boolean = true;
  drawerOpen = false;
  userOrContactDrawer;
  isForContact: boolean = false;
  openSideModal: boolean = false;

  @Input() current_company;

  @Output() openAddClientModalEvent = new EventEmitter();
  @Output() openAddClientExistingUsersModalEvent = new EventEmitter();
  @Output() removeClientUserEvent = new EventEmitter();
  @Output() declineEvent = new EventEmitter();
  @Output() openAddStaffUserModalEvent = new EventEmitter();
  @Output() unassignAccountantFromClientEvent = new EventEmitter();
  @Output() removeInviteEvent = new EventEmitter();
  @Output() viewInviteLinkEvent = new EventEmitter();
  @Output() sendInviteEmailEvent = new EventEmitter();
  @Output() deleteContactEvent = new EventEmitter();
  @Output() inviteContactToBecomeClientEvent = new EventEmitter();

  constructor(
    private customDataService: CustomDataService,
    private cdr: ChangeDetectorRef,
    private genericDrawerService: GenericDrawerService,
  ) {}

  ngOnInit(): void {}

  ngOnChanges(changes: SimpleChanges) {}

  openDrawer(userOrContact) {
    if (!userOrContact.user) this.isForContact = true;
    else this.isForContact = false;
    this.userOrContactDrawer = userOrContact;
    this.cdr.detectChanges();
    this.drawerOpen = true;
  }

  changeHide(val: boolean) {
    this.drawerOpen = val;
  }

  openAddClientModal() {
    this.openAddClientModalEvent.emit(this.current_company);
  }

  openAddClientExistingUsersModal() {
    this.openAddClientExistingUsersModalEvent.emit(this.current_company);
  }

  removeClientUser(user) {
    this.removeClientUserEvent.emit(user);
  }

  decline() {
    this.declineEvent.emit();
  }

  openAddStaffUserModal() {
    this.openAddStaffUserModalEvent.emit(this.current_company);
  }

  unassignAccountantFromClient(user_id) {
    const { id: company_id } = this.current_company;
    this.unassignAccountantFromClientEvent.emit({ user_id, company_id });
  }

  removeInvite(invite_id) {
    this.removeInviteEvent.emit(invite_id);
  }

  viewInviteLink(invite) {
    this.viewInviteLinkEvent.emit(invite);
  }

  sendInviteEmail(invite_id) {
    this.sendInviteEmailEvent.emit(invite_id);
  }

  deleteContact(contact_uuid) {
    this.deleteContactEvent.emit(contact_uuid);
  }

  inviteContactToBecomeClient(event, contact) {
    if (event) event.stopPropagation();
    this.inviteContactToBecomeClientEvent.emit(contact);
  }

  openDropdownWithoutTriggeringParentClick(event) {
    event.stopPropagation();
  }

  getContactEmailFromDataFieldValues(dataFieldValues) {
    const { value: email } = dataFieldValues.find(
      ({ field }) => field.key === "primary_email",
    );
    return email;
  }
}
